import { css } from "@emotion/react";

const dynamicPadding = props => css`
  padding: ${props.theme.space[5]}px 20px;

  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    padding: ${props.theme.space[7]}px 48px;
  }
`;

const dynamicBorderRadius = props => css`
  border-radius: 24px;

  @media (min-width: ${props.theme.screenSizes.mdMax}) {
    border-radius: 35px;
  }
`;

export const addStyles = props => css`
  position: absolute;
  height: auto;
  left: 0;
  right: 0;

  ${dynamicPadding(props)};
  ${dynamicBorderRadius(props)};
`;
